(function () {
  var roots = document.querySelectorAll("[data-agave-rally]");

  roots.forEach(function (root) {
    var form = root.querySelector("[data-rally-form]");
    if (!form) return;

    var endpoint = (root.getAttribute("data-form-endpoint") || "").trim();
    var shirtPrice = Number(root.getAttribute("data-shirt-price") || "35");
    var shirtsClosed = root.getAttribute("data-shirts-closed") === "true";
    var status = form.querySelector("[data-rally-status]");
    var confirmation = form.querySelector("[data-rally-confirmation]");
    var confirmationMessage = form.querySelector("[data-rally-confirmation-message]");
    var submitButton = form.querySelector(".agave-rally__submit");
    var totalTargets = root.querySelectorAll("[data-rally-total]");
    var shirtCountInput = form.querySelector('input[name="shirtCount"]');
    var invoiceTotalInput = form.querySelector('input[name="invoiceTotal"]');
    var submissionIdInput = form.querySelector('input[name="submissionId"]');
    var waiverAcceptedAtInput = form.querySelector('input[name="waiverAcceptedAt"]');
    var passengerInfoFields = form.querySelectorAll("[data-passenger-info]");
    var passengerWaiverInput = form.querySelector("[data-passenger-waiver]");
    var phoneInput = form.querySelector("[data-phone-format]");

    function selectedValue(name) {
      var checked = form.querySelector('input[name="' + name + '"]:checked');
      return checked ? checked.value : "no";
    }

    function fieldValue(name) {
      var field = form.querySelector('[name="' + name + '"]');
      return field ? String(field.value || "").trim() : "";
    }

    function formatPhone(value) {
      var digits = String(value || "").replace(/\D/g, "");

      if (digits.length === 11 && digits.charAt(0) === "1") {
        digits = digits.slice(1);
      }

      digits = digits.slice(0, 10);

      if (digits.length > 6) {
        return "(" + digits.slice(0, 3) + ") " + digits.slice(3, 6) + "-" + digits.slice(6);
      }

      if (digits.length > 3) {
        return "(" + digits.slice(0, 3) + ") " + digits.slice(3);
      }

      if (digits.length > 0) {
        return "(" + digits;
      }

      return "";
    }

    function syncPhone() {
      if (!phoneInput) return;
      phoneInput.value = formatPhone(phoneInput.value);
    }

    function setStatus(message, state) {
      if (!status) return;
      status.textContent = message || "";
      if (state) {
        status.setAttribute("data-state", state);
      } else {
        status.removeAttribute("data-state");
      }
    }

    function hideConfirmation() {
      if (confirmation) confirmation.hidden = true;
      if (confirmationMessage) confirmationMessage.textContent = "";
    }

    function showConfirmation(driverEmail, passengerEmail, submissionId, invoiceTotal) {
      if (!confirmation || !confirmationMessage) return;

      var messageParts = [
        "Your application was submitted.",
        "A confirmation email was sent to " + driverEmail + "."
      ];

      if (passengerEmail && passengerEmail.toLowerCase() !== driverEmail.toLowerCase()) {
        messageParts.push("Passenger/guardian copy sent to " + passengerEmail + ".");
      }

      if (Number(invoiceTotal) > 0) {
        messageParts.push("Shirt invoice total: $" + invoiceTotal + ".");
      }

      messageParts.push("Submission ID: " + submissionId + ".");

      confirmationMessage.textContent = messageParts.join(" ");
      confirmation.hidden = false;

      if (typeof confirmation.focus === "function") {
        try {
          confirmation.focus({ preventScroll: true });
        } catch (error) {
          confirmation.focus();
        }
      }

      if (typeof confirmation.scrollIntoView === "function") {
        confirmation.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    function hasPassengerInfo() {
      return Array.prototype.some.call(passengerInfoFields, function (field) {
        return String(field.value || "").trim();
      });
    }

    function syncPassengerWaiver() {
      if (!passengerWaiverInput) return;

      var isRequired = hasPassengerInfo();
      passengerWaiverInput.required = isRequired;
      passengerWaiverInput.setAttribute("aria-required", isRequired ? "true" : "false");

      if (!isRequired) {
        passengerWaiverInput.checked = false;
      }
    }

    function syncShirt(group) {
      var noInput = form.querySelector('input[name="' + group + 'Shirt"][value="no"]');
      var yesInput = form.querySelector('input[name="' + group + 'Shirt"][value="yes"]');
      var wantsShirt = selectedValue(group + "Shirt") === "yes";
      var wrapper = form.querySelector('[data-shirt-size-for="' + group + '"]');
      var select = form.querySelector('select[name="' + group + 'ShirtSize"]');

      if (shirtsClosed) {
        if (noInput) noInput.checked = true;
        if (yesInput) {
          yesInput.checked = false;
          yesInput.disabled = true;
          yesInput.setAttribute("aria-disabled", "true");
        }
        wantsShirt = false;
      }

      if (wrapper) wrapper.hidden = !wantsShirt;
      if (select) {
        select.disabled = !wantsShirt;
        select.required = wantsShirt;
        if (!wantsShirt) select.value = "";
      }
    }

    function updateTotal() {
      var shirtCount = 0;
      if (!shirtsClosed && selectedValue("driverShirt") === "yes") shirtCount += 1;
      if (!shirtsClosed && selectedValue("passengerShirt") === "yes") shirtCount += 1;

      var invoiceTotal = shirtCount * shirtPrice;
      if (shirtCountInput) shirtCountInput.value = String(shirtCount);
      if (invoiceTotalInput) invoiceTotalInput.value = String(invoiceTotal);

      totalTargets.forEach(function (target) {
        target.textContent = "$" + String(invoiceTotal);
      });
    }

    function syncForm() {
      syncShirt("driver");
      syncShirt("passenger");
      syncPassengerWaiver();
      syncPhone();
      updateTotal();
    }

    function createSubmissionId() {
      var random = Math.random().toString(36).slice(2, 8).toUpperCase();
      return "ARR-" + Date.now().toString(36).toUpperCase() + "-" + random;
    }

    form.addEventListener("change", function (event) {
      var target = event.target;
      if (!target || !target.name) return;
      hideConfirmation();
      if (target.name === "driverShirt" || target.name === "passengerShirt") {
        syncForm();
      } else if (target.hasAttribute("data-passenger-info")) {
        syncPassengerWaiver();
      }
    });

    form.addEventListener("input", function (event) {
      var target = event.target;
      if (!target) return;

      hideConfirmation();

      if (target === phoneInput) {
        syncPhone();
      } else if (target.hasAttribute("data-passenger-info")) {
        syncPassengerWaiver();
      }
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      syncForm();
      setStatus("");
      hideConfirmation();

      if (!form.reportValidity()) {
        setStatus("Please finish the required fields before submitting.", "error");
        return;
      }

      if (!endpoint) {
        setStatus("This application page is almost ready. The Google Sheet connection still needs to be added.", "error");
        return;
      }

      var submissionId = createSubmissionId();
      var driverEmail = fieldValue("email");
      var passengerEmail = fieldValue("passengerEmail");
      var invoiceTotal = invoiceTotalInput ? invoiceTotalInput.value : "0";

      if (submissionIdInput) submissionIdInput.value = submissionId;
      if (waiverAcceptedAtInput) waiverAcceptedAtInput.value = new Date().toISOString();

      var payload = new URLSearchParams(new FormData(form));
      payload.set("submittedAt", new Date().toISOString());
      payload.set("sourcePage", window.location.href);

      if (submitButton) submitButton.disabled = true;
      setStatus("Submitting application...");
      var submittedSuccessfully = false;

      fetch(endpoint, {
        method: "POST",
        mode: "no-cors",
        body: payload
      })
        .then(function () {
          submittedSuccessfully = true;
          setStatus("Application submitted. A confirmation email was sent to " + driverEmail + ".", "success");
          if (submitButton) {
            submitButton.textContent = "Application submitted";
          }
          showConfirmation(driverEmail, passengerEmail, submissionId, invoiceTotal);
        })
        .catch(function () {
          setStatus("The application could not be submitted. Please try again or contact the event team.", "error");
        })
        .finally(function () {
          if (submitButton && !submittedSuccessfully) submitButton.disabled = false;
        });
    });

    syncForm();
  });
})();
